import styled from 'styled-components';
import {rgba} from 'polished';
import {primary, neutral, white} from '../../style/colors';

export const SectionWrapper = styled.div`
  background: ${white};
  border-radius: 12px;
  padding: 0;
  margin-bottom: 20px;
  scroll-margin-top: 150px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  transition: box-shadow 0.3s ease;
  overflow: hidden;

  &:hover {
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  }
`;

export const SectionHeader = styled.div`
  padding: 24px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  user-select: none;
  transition: background-color 0.2s ease;

  &:hover {
    background: ${neutral[50]};
  }

  ${(props) =>
    !props.collapsible &&
    `
    cursor: default;

    &:hover {
      background: transparent;
    }
  `}
`;

export const HeaderContent = styled.div`
  flex: 1;
  font-size: 22px;
  font-weight: 700;
  color: ${neutral[900]};
  letter-spacing: -0.3px;
`;

export const ToggleButton = styled.button`
  background: transparent;
  border: none;
  color: ${primary[500]};
  font-size: 24px;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.3s ease;
  width: 32px;
  height: 32px;
  border-radius: 50%;

  &:hover {
    background: ${rgba(primary[500], 0.1)};
  }

  ${(props) =>
    !props.collapsed &&
    `
    transform: rotate(180deg);
  `}
`;

export const SectionContent = styled.div`
  padding: 0 24px 24px;
  max-height: ${(props) => (props.collapsed ? '0' : '10000px')};
  opacity: ${(props) => (props.collapsed ? '0' : '1')};
  overflow: hidden;
  transition: max-height 0.4s ease, opacity 0.3s ease, padding 0.3s ease;

  ${(props) =>
    props.collapsed &&
    `
    padding: 0 24px;
  `}
`;
